import PropTypes from 'prop-types';

import { withSearchBlueprint } from '../redux/blueprints/search';

const blueprint = withSearchBlueprint('dummy');

export default PropTypes.shape(Object.keys(blueprint)
  .filter(key => typeof blueprint[key] === 'function')
  .reduce((type, key) => ({ ...type, [key]: PropTypes.func }), {}));
